import { GameState } from '../model/interfaces';
import React from 'react';
import styles from '../styles/statusMessage.module.scss';
import { useBehaviorSubject } from '@base/utils/helpers';

export default function StatusMessage(props: { gameState: GameState }) {
  const statusMessage = useBehaviorSubject(
    props.gameState.onStatusMessagesChanged
  );

  return <div className={styles.statusMessage}>{statusMessage}</div>;
}
